/* eslint-disable no-alert */
import React, { useState } from 'react';
import { CheckboxGroup } from '@uhg-abyss/web/ui/CheckboxGroup';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';

export const CheckBoxTextBox = (props) => {
  const [checkBoxValue, setCheckBoxValue] = useState(['']);
  const [question] = useState(props);
  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });

  const deselectEnableValues: string[] = [];
  question?.qstn?.options.forEach((optn) => {
    if (optn.values[0].deselectEnabled === true)
      deselectEnableValues.push(optn.values[0].id);
  });

  const updateCheckBox = (event: string[]) => {
    let modifiedValues: string[] = [];
    if (
      event.length > 0 &&
      deselectEnableValues.indexOf(event[event.length - 1]) !== -1
    ) {
      modifiedValues.push(event[event.length - 1]);
    } else if (event.length > 0 && deselectEnableValues.includes(event[0])) {
      modifiedValues = event.slice(1, event.length);
    } else {
      modifiedValues = event;
    }
    question.form.setValue(`qstn-${question.qstn.questionId}`, modifiedValues);
    question.qstn.selectedValues = modifiedValues;
    setCheckBoxValue(modifiedValues);
  };

  return (
    <React.Fragment>
      <div key={question?.qstn?.questionId}>
        <CheckboxGroup
          label={<strong>{`${question.serial}. ${question.qstn?.questionText}`}</strong>}
          model={`qstn-${question?.qstn?.questionId}`}
          key={`chktb-${question?.qstn?.questionId}`}
          validators={{ required: 'Please select at least one option' }}
          onChange={(e: string[]) => {
            updateCheckBox(e);
          }}
        >
          <CheckboxGroup.Column>
          {question.qstn?.options.map((opt, idx) => {
            return (
              <div
                key={`chk-${question?.qstn?.questionId}-${idx}`}
                style={{ marginTop: '8px' }}
              >
                <Checkbox
                  label={opt.values[0].value}
                  value={opt.values[0].id}
                  key={opt.id}
                />
                {opt.values[0]['additional text'] !== undefined &&
                checkBoxValue.includes(opt.values[0].id) ? (
                  <TextInput
                    id="textarea"
                    key={`text-${question?.qstn?.questionId}`}
                    model={`text-${question?.qstn?.questionId}`}
                    label={opt.values[0]['additional text']}
                    isClearable
                    validators={{
                      required: 'Please enter at least 4 characters',
                      minLength: {
                        value: 4,
                        message: 'Please enter at least 4 characters',
                      },
                    }}
                  />
                ) : null}
              </div>
            );
          })}
          </CheckboxGroup.Column>
        </CheckboxGroup>
      </div>
    </React.Fragment>
  );
};
